module.exports = {
    PHONE_CONTACT_TIME: "TELEPHONE",
    EMAIL_CONTACT_TIME: "EMAIL"
};
